import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_APPLICATION_STATUS} from '../../constants/apiUrls';
import {GET_NON_NATIONAL_APPLICATION_STATUS_QUERY_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface NonNationalApplicationStatusResponse {
  uuid: string;
  status: string;
  candidateRemark: string;
  internalRemark: string;
  adminUpdatedByName: string;
  adminUpdatedAt: string;
  lockedByUser?: string;
  editable: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: NonNationalApplicationStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalApplicationStatus = ({uuid, onSuccess, onError}: Input) => {
  const getNonNationalApplicationStatus = async () => {
    const res = await axiosClient.get<NonNationalApplicationStatusResponse>(
        GET_NON_NATIONAL_APPLICATION_STATUS(uuid)
    );
    return res.data;
  };
  return useCustomQuery(
      [GET_NON_NATIONAL_APPLICATION_STATUS_QUERY_KEY],
      getNonNationalApplicationStatus,
      {
        onSuccess,
        onError,
      }
  );
};
